<template>
  <div class="formWrapper filled">
    <div class="form-header floatCss">
      <b-row>
        <b-col cols="12">
          <div class="form-header-inner d-flex justify-content-between">
            <div class="d-flex">
              <div class="dForm-top-logo">
                <img :src="logoSrc">
              </div>
              <div class="dForm-companyDetails">
                <div class="dForm-cmBlock">
                  <h2>
                    <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                  </h2>
                </div>
                <div class="dForm-cmBlock2">
                  <p>(Co. Reg. No. 200401183W)</p>
                  <p>(GST Group Reg. No. M90364395L)</p>
                </div>
              </div>
            </div>
            <div class="dForm-top-right d-flex">
              <h5>File No: {{ formData.fileNo || '-' }}</h5>
              <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="pp-section-tittle">
            <h2>authorised personS form 授权人表格</h2>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="form-content floatCss">
      <b-row>
        <b-col cols="12">
          <div class="apf-section floatCss">
            <h5>(Only applicable to Niche/Pedestal) In my absence, I hereby authorise the Group to:</h5>
            <ul>
              <li>Disclose information about location of the niche/pedestal to the authorised person(s).</li>
              <li>For niches, permit the authorised person(s) to decide on the addition or removal of decorative items from the niche (with no authority to remove the urn/ashes).</li>
              <li>In the unlikely event of the purchaser’s death or incapacity, and with documentary proof provided, allow the authorised person(s) to update Next-Of-Kin contact information and decide who to have access to the niche.</li>
            </ul>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="apf-table-section floatCss">
            <h4>It is explicitly stated that the authorised person(s) do not possess the authority to make changes to the Purchaser, Ownership Transfer, or nominate the intended user for the mentioned products.</h4>
            <div class="pp-section-tittle2">
              <h2>Authorised Person(s) 授权人</h2>
            </div>
            <div class="apf-table-block floatCss">
              <table class="table">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Name</th>
                    <th>NRIC No.</th>
                    <th>Contact No.</th>
                    <th>Relationship</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(person, key) in formData.authorizedPersons"
                    :key="key"
                  >
                    <td>{{ key + 1 }}</td>
                    <td>{{ person.name }}</td>
                    <td>{{ person.nric }}</td>
                    <td>{{ person.contact }}</td>
                    <td>{{ person.relation }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p>**Please note that if this section is left blank, the Group will only take instructions and disclose information pertaining to this purchase from you.</p>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="formFooter floatCss">
      <b-row class="footer-signature-area">
        <b-col cols="12">
          <div class="pp-signature-area floatCss">
            <p>Purchaser 购买者签名</p>
          </div>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col
              cols="6"
              md="6"
              lg="6"
            >
              <div class="pp-signature-block floatCss">
                <img
                  v-if="formData.apSign"
                  :src="formData.apSign"
                  alt="signature"
                >
                <span v-else />
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <div class="pp-signature-area floatCss">
            <h4>Name 姓名: {{ formData.customerName }}</h4>
            <h4>Date 日期: {{ (formData.apSignDate ? dateFormatWithTime(formData.apSignDate) : '') }}</h4>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      logoSrc: require('@/assets/images/logo/nr-logo.png'),
      formData: JSON.parse(localStorage.getItem('installmentFormData')) || {},
    }
  },
}
</script>
